export function posNumberonChange(field: any, form: any) {
	return (e: React.ChangeEvent<HTMLInputElement>) =>
		form.setFieldValue(field.name, isNaN(e.target.valueAsNumber) ? null : e.target.valueAsNumber);
}
